import { initialize } from './client/initialize';

export const client = initialize();
